import i18n from 'i18next';

import { getTimeSelectOptions, getTimeZoneSelectOptions } from '@/exceed';

import getAvailableEventTypesOptions from '../helpers/getAvailableEventTypesOptions';
import getLiveVideoSpeakers from '../helpers/getLiveVideoSpeakers';

import { UserSelectedOption, UserSelectOption } from '../../exceed/components/userSelect';

export default ({ adminSettings, isEditMode, settingsUrl }) => ({
  location_type: {
    type: 'Select',
    label: i18n.t('location-type-label'),
    selectProps: { isFluid: true, isFullWidth: true },
    options: getAvailableEventTypesOptions({ adminSettings }),
    validators: [{ type: 'isRequired' }],
    isDisabled: isEditMode,
  },
  edit_settings: {
    type: 'Button',
    isDecoration: true,
    text: i18n.t('edit-settings'),
    handleOnClick: () => { window.open(settingsUrl, '_blank'); },
    conditions: [{ type: 'videos:isSettingsUrlEmpty', shouldHideField: true }],
  },
  live_broadcast_url: {
    type: 'Text',
    label: i18n.t('live-video-url-label'),
    help: i18n.t('live-video-url-help'),
    validators: [{ type: 'isNotEmptyString' }, { type: 'isRequiredIfVisible' }],
    conditions: [{ type: 'videos:isLocationTypeNotURL', shouldHideField: true }],
  },
  zoom_account_email: {
    type: 'Text',
    label: i18n.t('zoom-host-email-label'),
    help: i18n.t('zoom-host-email-help'),
    conditions: [{ type: 'videos:isLocationTypeNotZoom', shouldHideField: true }],
    isDisabled: isEditMode,
  },
  name: {
    type: 'Text',
    label: i18n.t('agenda-label'),
    help: i18n.t('agenda-help'),
    validators: [{ type: 'isNotEmptyString' }, { type: 'isRequired' }],
    maxLength: 100,
  },
  start_date: {
    type: 'Date',
    placeholder: i18n.t('select-date'),
    label: i18n.t('agenda-date'),
    help: i18n.t('agenda-date-help'),
    validators: [{ type: 'isRequired' }],
  },
  start_zone: {
    type: 'Select',
    label: i18n.t('agenda-timezone-label'),
    selectProps: { isFluid: true, isFullWidth: true },
    validators: [{ type: 'isRequired' }],
    options: getTimeZoneSelectOptions({ adminSettings }),
  },
  start_time: {
    type: 'Select',
    label: i18n.t('agenda-start-time-label'),
    validators: [{ type: 'isRequired' }],
    options: getTimeSelectOptions(),
    selectProps: { isSearchable: true },
  },
  start_time_info: {
    type: 'Info',
    isDecoration: true,
    text: i18n.t('agenda-start-time-info'),
  },
  duration: {
    type: 'Duration',
    label: i18n.t('duration'),
    validators: [{ type: 'isRequired' }],
    hourOptions: {
      start: 0,
      count: 24,
    },
    minuteOptions: {
      start: 0,
      count: 55,
      increment: 5,
    },
  },
  rrule: {
    type: 'EventRepeat',
    label: i18n.t('agenda-repeat-label'),
    validators: [{ type: 'isRequired' }, { type: 'isUntilRequired' }],
  },
  rrule_info: {
    type: 'Info',
    isDecoration: true,
    text: i18n.t('repeat-info'),
    conditions: [{ type: 'isFrequencySelected', shouldHideField: true }],
  },
  speakers: {
    type: 'AutoCompleteSearch',
    label: i18n.t('agenda-speakers-label'),
    handleLoadOptions: getLiveVideoSpeakers,
    CustomSelectedOptionItem: UserSelectedOption,
    selectProps: {
      noOptionsMessage: () => i18n.t('agenda-speakers-empty'),
      placeholder: i18n.t('agenda-speakers-placeholder'),
      components: { Option: UserSelectOption },
    },
  },
  description: {
    type: 'TextArea',
    label: i18n.t('description'),
  },
});
